import { AnalyticsBrowser } from '@segment/analytics-next';
import getEnv from '../env';
import { User } from './types/User';
import useABTestStore from '../stores/abTestStore';

export const analytics = AnalyticsBrowser.load({ writeKey: getEnv().segment_api_key });

let prevPath: string | null = null;

function trackCurrentPage(pathname: string) {
  if (getEnv().segment_api_key && pathname !== prevPath) {
    prevPath = pathname;
    analytics.page(undefined, undefined, { abTests: useABTestStore.getState().ABTestsValues });
  }
}

function trackEvent(eventName: string, payload: { [key: string]: any }) {
  analytics.track(eventName, {
    ...payload,
    abTests: useABTestStore.getState().ABTestsValues,
  });
}

function identifyUser(user: User) {
  analytics.identify(user.id, {
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    sizeOfPortfolio: user?.sizeOfPortfolio ?? undefined,
  });
}

function setAnonymousUserId(id: string) {
  return analytics.setAnonymousId(id);
}

export { trackCurrentPage, trackEvent, identifyUser, setAnonymousUserId };
